<template>
  <div v-if="displayed" class="splash-screen">
      <div class="splash-screen__content">
        <img src="../assets/logo.svg?url" alt="Kidjo TV" width="70%">
        <div class="loader"><div></div><div></div></div>
      </div>
  </div>
</template>

<script>
  export default {
    props: {
      autoHide: {
        default: false,
      },
    },
    data() {
      return {
        displayed: true,
      };
    },
    methods: {
      hide() {
        this.displayed = false;
      },
    },
    mounted() {
      if (this.autoHide) {
        setTimeout(() => {
          this.hide();
        }, 2000);
      }
    },
  };
</script>

<style scoped lang="scss">
  @import '../assets/styles/breakpoints.scss';

  .splash-screen {
    position: absolute;
    z-index: 1010;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    &::before {
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, .85);
      backdrop-filter: blur(2px);
      content: '';
    }

    &__content {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      z-index: 2;

      img {
        z-index: 2;
        width: 160px;
        margin-bottom: 30px;

        @media (min-width: $breakpoint-lg) {
          width: 240px;
          margin-bottom: 40px;
        }
      }
    }
  }

.loader {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  div {
    position: absolute;
    border: 4px solid #2ab5f6;
    opacity: 1;
    border-radius: 50%;
    animation: loader-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;

    &:nth-child(2) {
      animation-delay: -0.5s;
    }
  }
}

  @keyframes loader-ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }

</style>
